import styled, { css } from 'styled-components';

import { COLORS } from '../../../tokens/colors';
import { FONTS } from '../../../tokens/fonts';
import { wideBreakpoints } from '../../layouts/wideContainer';

export const Container = styled.div`
    min-width: 320px;
    max-width: 700px;
    padding: 32px;
    ${FONTS.M};
    flex-direction: column;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 24px;
        min-width: 100%;
    }
`;

export const Icon = styled.img`
    width: 56px;
    height: 56px;
`;

export const Title = styled.div<{ isIcon: boolean }>`
    ${FONTS.H3};
    color: ${COLORS.TextPrimary};
    ${({ isIcon }) => isIcon
        ? css`
            width: 100%;
            margin-top: 16px;
        `
        : css`
            width: calc(100% - 42px);
            margin-top: 0;
        `
    }

    p {
        margin: 0;
    }
`;

export const Text = styled.div`
    margin: 4px 0 0;
    color: ${COLORS.TextInfo};
    ${FONTS.S};

    p {
        margin: 0;
    }
`;

export const Content = styled.div`
    display: block;
    width: 100%;
    margin-top: 16px;
`;
